import React from 'react'

import analytics from './images/analytics.webp';
import suggestions from './images/suggestions.webp';
import aorb from './images/aorb.webp';

import StartFooterCTA from './StartFooterCTA.js';


export default class extends React.Component {

  render() {
    document.title = "Roadmap · Citrus by Polymedia";
    let alt_nl = document.createElement('link');alt_nl.rel = 'alternate';alt_nl.hreflang = 'x-default';alt_nl.href = 'https://citrus.polymedia.nl/roadmap';
    document.getElementsByTagName('title')[0].after(alt_nl);
    let alt_en = document.createElement('link');alt_en.rel = 'alternate';alt_en.hreflang = 'en';alt_en.href = 'https://citrus.polymedia.nl/en/roadmap';
    document.getElementsByTagName('title')[0].after(alt_en);
    return (
      <div>

        <div className="full greyish">
          <div className="wrap wrap-thin">
            <small style={{opacity:".5", display:"block", marginTop:"3em", fontSize:"75%", textAlign:"justify"}}>{this.props.i18n_texts["roadmap_disclaimer"][this.props.app_language]}</small>
            <small style={{opacity:".5", display:"block", marginTop:"1em", fontSize:"75%", textAlign:"right"}}>{this.props.i18n_texts["gen_lastmodified"][this.props.app_language]} 17-4-2024.</small>
            <div className="timeline">

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>{this.props.i18n_texts["gen_new"][this.props.app_language]}</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_pollshare_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_pollshare_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>{this.props.i18n_texts["gen_new"][this.props.app_language]}</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_pollaorb_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_pollaorb_text"][this.props.app_language]}</p>
                  <img src={aorb} alt={this.props.i18n_texts["roadmap_pollaorb_img_alt"][this.props.app_language]} className="screenshot" />
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>{this.props.i18n_texts["gen_new"][this.props.app_language]}</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_embedonce_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_embedonce_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>{this.props.i18n_texts["gen_comingsoon"][this.props.app_language]}</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_feedbackwidget_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_feedbackwidget_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>Q3 2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_analytics2_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_analytics2_text"][this.props.app_language]}</p>
                  <ul>
                    <li>{this.props.i18n_texts["roadmap_analytics2_subtext1"][this.props.app_language]}</li>
                    <li>{this.props.i18n_texts["roadmap_analytics2_subtext2"][this.props.app_language]}</li>
                    <li>{this.props.i18n_texts["gen_andmore"][this.props.app_language]}</li>
                  </ul>
                  <img src={analytics} alt={this.props.i18n_texts["roadmap_analytics2_img_alt"][this.props.app_language]} className="screenshot" />
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>Q3 2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_pollaorbwithmedia_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_pollaorbwithmedia_text"][this.props.app_language]}</p>
                  <img src={aorb} alt={this.props.i18n_texts["roadmap_pollaorbwithmedia_img_alt"][this.props.app_language]} className="screenshot" />
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>Q3 2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_customcolors_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_customcolors_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>Q3 2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_articlepolls_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_articlepolls_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>Q3 2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_searchresultpolls_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_searchresultpolls_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_generalfeedbackpolls_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_generalfeedbackpolls_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>2024</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_wordpressplugin_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_wordpressplugin_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>?</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_pollsuggestions_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_pollsuggestions_text"][this.props.app_language]}</p>
                  <img src={suggestions} alt={this.props.i18n_texts["roadmap_pollsuggestions_img_alt"][this.props.app_language]} className="screenshot" />
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>?</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_pollplaylists_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_pollplaylists_text"][this.props.app_language]}</p>
                </div>
              </div>

              <div className="tl-item">
                <div className="col-3 tl-stamp">
                  <p>?</p>
                </div>
                <div className="col-9 tl-content">
                  <h1>{this.props.i18n_texts["roadmap_emailcollection_title"][this.props.app_language]}</h1>
                  <p>{this.props.i18n_texts["roadmap_emailcollection_text"][this.props.app_language]}</p>
                </div>
              </div>

            </div>
          </div>
        </div>

        <StartFooterCTA lang={this.props.app_language} openModal={this.props.openModal} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/StartPages/Roadmap.js